import { render, staticRenderFns } from "./ValueSpaceSelectSlideover.vue?vue&type=template&id=6de81ef6"
import script from "./ValueSpaceSelectSlideover.vue?vue&type=script&lang=js"
export * from "./ValueSpaceSelectSlideover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports